import React, { useState } from 'react';
import { Button } from 'antd';
import SetPasswordModal from './SetPasswordModal';
import styles from './passwordSettings.module.scss';

interface PasswordSettingsProps {
  userName?: string;
  isSubmitting?: boolean;
  onSubmit: (newPassword: string, onSuccess: () => void) => void;
  onSetPasswordClick?: () => void;
}

const PasswordSettings: React.FC<PasswordSettingsProps> = ({ userName, isSubmitting, onSubmit, onSetPasswordClick }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    if (onSetPasswordClick) {
      onSetPasswordClick();
      return;
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <section className={styles.section} aria-labelledby="profile-password-settings">
      <h2 className={styles.heading} id="profile-password-settings">
        Password Settings
      </h2>

      <Button className={styles.button} onClick={openModal}>
        Set Password
      </Button>

      <SetPasswordModal open={isModalOpen} onClose={closeModal} userName={userName} isSubmitting={isSubmitting} onSubmit={onSubmit} />
    </section>
  );
};

export default PasswordSettings;
